import { BASE_URL } from './sitemap-pages';

export interface BreadcrumbItem {
  name: string;
  path?: string;
}

export function createBreadcrumbList(
  items: BreadcrumbItem[],
): Record<string, unknown> {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      ...(item.path !== undefined ? { item: `${BASE_URL}${item.path}` } : {}),
    })),
  };
}
